<template>
    <td>
        <div v-if="readonly">
            {{ noSubstance ? noSubstanceLabel : substanceWeightDisplay }}
        </div>
        <div v-else>
            <template v-if="noSubstance">
                <div class="text-muted">{{ noSubstanceLabel }}</div>
            </template>
            <template v-else>
                <WeightFieldOperator
                    :value="substance.weight"
                    :edit-key="editKey"
                    @input="$emit('input', $event)"
                    @editing="$emit('editing', $event)"
                />
                <div v-if="touched && substanceWeightError" class="text-danger small">
                    {{ substanceWeightError }}
                </div>
            </template>
        </div>
    </td>
</template>

<script>
import { WeightFieldOperator } from '@/views/product/components/product-card/fmd/common'

export default {
    name: 'FmdSubstanceWeightCell',
    components: {
        WeightFieldOperator,
    },
    props: {
        substance: {
            type: Object,
            required: true,
        },
        substanceWeightDisplay: {
            type: String,
            default: '-',
        },
        substanceWeightError: {
            type: String,
            default: '',
        },
        noSubstance: {
            type: Boolean,
            default: false,
        },
        noSubstanceLabel: {
            type: String,
            default: '',
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        touched: {
            type: Boolean,
            default: false,
        },
        editKey: {
            type: String,
            default: '',
        },
    },
}
</script>
